import axios from 'axios';
import Cookies from 'js-cookie';
import { API_CONFIG } from '../config/apiConfig';

const instance = axios.create({
  baseURL: API_CONFIG.BASE_URL,
  // ...other config...
});

// Add userId to headers for every request
instance.interceptors.request.use(config => {
  const userId = Cookies.get('userId');
  if (userId) {
    config.headers['x-user-id'] = userId; // Or use Authorization if preferred
  }
  return config;
});

export default instance;